<template>
  <div>
    <!-- Comment Modal -->
    <div
      class="modal fade"
      id="comment-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white text-bold">Comments</h5>
          </div>
          <div class="modal-body bg-white">
            <div>
              <div
                class="comment-container"
                v-for="(comment, index) in comments"
                :key="index"
              >
                <div v-if="comment.text" class="comment-entry">
                  <p class="comment-holder">
                    <span class="text-bold">- {{ comment.text }}</span>
                    <small class="text-primary"
                      >( {{ comment.username }} )</small
                    >
                  </p>
                  <button
                    class="btn btn-sm btn-danger float-right"
                    @click="deleteComments(index)"
                  >
                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div class="form-group mt-10">
                <input
                  type="text"
                  @keyup.enter="submit"
                  placeholder="Write Comment"
                  v-model="comment"
                  class="form-control"
                />
              </div>
              <button class="btn btn-block btn-primary" @click="submit">
                Submit
              </button>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["order"],

  data() {
    return {
      comments: [],
      comment: null,
    };
  },

  watch: {
    "order.comments": function () {
      this.comments = this.order.comments;
    },

    order: function () {
      this.comments = this.order.comments;
    },
  },

  mounted() {
    this.comments = this.order.comments;
  },

  methods: {
    async deleteComments(index) {
      try {
        let res = await axios.put(
          "accessories_order/" + this.order.id,
          this.order
        );
        this.comments.splice(index, 1);
        this.$emit("submit", this.comments);
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },

    async submit() {
      if (this.comment) {
        try {
          let res = await axios.put(
            "accessories_order/" + this.order.id,
            this.order
          );
          this.comments.push({
            text: this.comment,
            username:
              this.$auth.user().first_name + " " + this.$auth.user().last_name,
          });
          this.$emit("submit", this.comments);
          this.comment = null;
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
          }
          this.comment = null;
        }
      }
    },
  },
};
</script>
<style>
.comment-container {
  padding: 10px;
}
.comment-container:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0.05);
}
.comment-entry {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.comment-holder {
  width: 80%;
}
</style>
